/**
 * WEB-2057 — положить ВСЕ пакеты строк воронки сразу, статически.
 *
 * Зовёт кабинет (`src/main.tsx`): превью конструктора рисует воронку на языке,
 * который автор переключает на лету, и ждать файл там нельзя — надписи обязаны
 * меняться тем же кадром. Лишний вес кабинету покупатель воронки не платит:
 * у публичной страницы свой вход сборки.
 *
 * ПУБЛИЧНЫЙ вход (`src/public-main.tsx`) этот файл не импортирует и не должен —
 * статический импорт отсюда вернул бы покупателю все 29 языков первым экраном.
 * Держится сторожем сборки (`build-guards/publicEntryGuard.ts`).
 *
 * Список файлов ЗДЕСЬ и каталог `quizStringPacks/` обязаны совпадать в обе
 * стороны — это проверяет `publicQuizStringsPacks.web2057.test.ts` обходом
 * каталога, а не списком руками.
 *
 * ЛЕЖИТ ВНЕ каталога пакетов намеренно: ленивый заказ пакета — это
 * `import('./quizStringPacks/<файл>.ts')` с подстановкой, и сборщик заводит
 * кусок на КАЖДЫЙ файл каталога. Лежи раздача там, она стала бы ещё одним
 * «языком» в этой россыпи.
 */
import { registerPublicQuizStringsPack } from './publicQuizStrings';
import { pack as ar } from './quizStringPacks/ar';
import { pack as cs } from './quizStringPacks/cs';
import { pack as da } from './quizStringPacks/da';
import { pack as de } from './quizStringPacks/de';
import { pack as el } from './quizStringPacks/el';
import { pack as es } from './quizStringPacks/es';
import { pack as fi } from './quizStringPacks/fi';
import { pack as fr } from './quizStringPacks/fr';
import { pack as he } from './quizStringPacks/he';
import { pack as hi } from './quizStringPacks/hi';
import { pack as hu } from './quizStringPacks/hu';
import { pack as id } from './quizStringPacks/id';
import { pack as it } from './quizStringPacks/it';
import { pack as ja } from './quizStringPacks/ja';
import { pack as ko } from './quizStringPacks/ko';
import { pack as nl } from './quizStringPacks/nl';
import { pack as no } from './quizStringPacks/no';
import { pack as pl } from './quizStringPacks/pl';
import { pack as pt } from './quizStringPacks/pt';
import { pack as ptBR } from './quizStringPacks/pt-BR';
import { pack as ro } from './quizStringPacks/ro';
import { pack as sv } from './quizStringPacks/sv';
import { pack as th } from './quizStringPacks/th';
import { pack as tr } from './quizStringPacks/tr';
import { pack as uk } from './quizStringPacks/uk';
import { pack as vi } from './quizStringPacks/vi';
import { pack as zh } from './quizStringPacks/zh';
import { pack as zhTW } from './quizStringPacks/zh-TW';

export function registerPublicQuizStringPacksEagerly(): void {
  registerPublicQuizStringsPack('ar', ar);
  registerPublicQuizStringsPack('cs', cs);
  registerPublicQuizStringsPack('da', da);
  registerPublicQuizStringsPack('de', de);
  registerPublicQuizStringsPack('el', el);
  registerPublicQuizStringsPack('es', es);
  registerPublicQuizStringsPack('fi', fi);
  registerPublicQuizStringsPack('fr', fr);
  registerPublicQuizStringsPack('he', he);
  registerPublicQuizStringsPack('hi', hi);
  registerPublicQuizStringsPack('hu', hu);
  registerPublicQuizStringsPack('id', id);
  registerPublicQuizStringsPack('it', it);
  registerPublicQuizStringsPack('ja', ja);
  registerPublicQuizStringsPack('ko', ko);
  registerPublicQuizStringsPack('nl', nl);
  registerPublicQuizStringsPack('no', no);
  registerPublicQuizStringsPack('pl', pl);
  registerPublicQuizStringsPack('pt', pt);
  registerPublicQuizStringsPack('pt-BR', ptBR);
  registerPublicQuizStringsPack('ro', ro);
  registerPublicQuizStringsPack('sv', sv);
  registerPublicQuizStringsPack('th', th);
  registerPublicQuizStringsPack('tr', tr);
  registerPublicQuizStringsPack('uk', uk);
  registerPublicQuizStringsPack('vi', vi);
  registerPublicQuizStringsPack('zh', zh);
  registerPublicQuizStringsPack('zh-CN', zh);
  registerPublicQuizStringsPack('zh-TW', zhTW);
}
